import { externalLinks } from "@/utils/external-links";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, IconButton, useTheme } from "@mui/material";

export function FloatingWhatsAppButton() {
  const theme = useTheme();

  const whatsappLink = externalLinks.whatsapp;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: "16px", md: "24px" },
        right: { xs: "16px", md: "24px" },
        zIndex: 1500,
      }}
    >
      <IconButton
        component="a"
        href={whatsappLink}
        target="_blank"
        rel="noopener"
        sx={{
          bgcolor: "#25D366",
          "&:hover": { bgcolor: "#1DA851" },
          color: theme.palette.common.white,
          width: { xs: 56, md: 64 },
          height: { xs: 56, md: 64 },
        }}
        aria-label="Fale conosco no WhatsApp"
      >
        <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
      </IconButton>
    </Box>
  );
}
